import toMap from '~/misc/toMap';

export default toMap([
  'GEOSEARCH_CRITERIA',
  'GEOSEARCH_RESULTS',
  'GEOSEARCH_SELECTED_PLACE',
  'GEOSEARCH_READY_PLACE',
  'GEOSEARCH_BLUR',
  'GEOSEARCH_FOCUS',
  'DELECT_GEOSEARCH_OPTION',
  'CHANGE_GEOSEARCH_SELECTED',

  'CREATE_OPTION',
  'MULTIPLE_GEOSEARCH_RESULTS',
  'MULTIPLE_SET_KEY',
  'MULTIPLE_SET_ISSHOW',
  'MULTIPLE_SELECTED',
  'MULTIPLE_GEOSEARCH_CRITERIA',
  'MULTIPLE_SET_TEMPORARY_DATA',
  'MULTIPLE_CHECK_SELECT_INPUT',
  'MULTIPLE_INIT_SELECT',
  'MULTIPLE_CLEAR',
  'GEOSEARCH_DELETE_LIST',
  'GEOSEARCH_SAVE_VALUE'
]);



// WEBPACK FOOTER //
// ./src/modules/geosearch/types.js